const registration = require('./registration'),
	remotes = require('./remotes');

module.exports = (() => {
	'use strict';

	return { registration, remotes };
})();
